var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGround(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M19.287 9.9c-.962-.693-2.148-1.009-3.324-.89-1.195.077-2.31.637-3.087 1.55-.797.89-1.162 2.08-1.005 3.267.1 1.148.663 2.2 1.56 2.912.92.708 2.077 1.033 3.23.904 1.208-.086 2.342-.612 3.19-1.483.85-.86 1.262-2.07 1.105-3.275-.07-1.206-.687-2.306-1.669-2.985z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear)",
    d: "M32.001 17.136c.005-4.361-1.745-8.536-4.846-11.569l-.342 1.952-3.324.263c1.579 1.009 2.537 2.764 2.542 4.648.223 2.497-1.077 4.701-3.894 6.629 1.271.598 2.442 1.386 3.476 2.343 1.01 1.019 1.608 2.377 1.68 3.816.146 1.397-.11 2.808-.745 4.06 3.47-3.07 5.458-7.493 5.453-12.142z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear)",
    d: "M10.647 27.475c1.726 1.837 4.154 2.832 6.663 2.731 1.228-.072 2.4-.535 3.343-1.33.967-.784 1.47-2.013 1.323-3.256-.128-1.349-.915-2.544-2.096-3.18-1.166-.675-2.513-.957-3.85-.809-.627.082-1.238.23-1.831.445-.877.306-1.73.68-2.556 1.105l.697-2.76c-3.32-1.047-5.121-3.146-5.401-6.298-.327-2.44.56-4.878 2.366-6.528.84-.76 1.807-1.373 2.85-1.808 1.19-.473 2.447-.76 3.723-.851.26-.024.607-.043 1.038-.057.432-.015.925-.005 1.48.023l2.432-.062c.527-.048 1.053-.12 1.575-.224.63-.14 1.252-.316 1.864-.527l.773-.267C22.38 1.98 19.226.995 16 1c-8.84 0-16 7.221-16 16.136 0 5.892 3.135 11.047 7.81 13.864l-.128-.115 2.964-3.41z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 16.409,
    x2: 16.409,
    y1: 0.999,
    y2: 33.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05DFB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2878D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 27.069,
    x2: 27.069,
    y1: 0.999,
    y2: 33.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05DFB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2878D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 12.521,
    x2: 12.521,
    y1: 1,
    y2: 33.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05DFB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2878D0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H32V32H0z",
    transform: "translate(0.000991821)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGround);
export default __webpack_public_path__ + "static/media/ground.9295a56638b7cf201d0950ae16f07217.svg";
export { ForwardRef as ReactComponent };